module.exports = __webpack_public_path__ + "static/img/banner.6e17539.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/生物制造/banner.png
// module id = ex8J
// module chunks = 16